import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWealth } from '../../../../api';
import { useWealthContext } from '../../../../contexts/wealth-context';
import { useBalanceSheetTableColDefs } from '../../../../hooks/useBalanceSheetTableColDefs';
import type { IModalBalanceEntry } from '../../../../interfaces/balance-sheet-table';
import { BalanceSheetCategoryTitle } from '../BalanceSheetCategoryTitle';
import { BalanceSheetTable } from '../BalanceSheetTable';

interface IProps {
    handleShowModal: (modalEntry: IModalBalanceEntry) => void;
}

export const IncomeTable: FunctionComponent<IProps> = ({ handleShowModal }) => {
    const { t } = useTranslation();
    const { clientCurrency } = useWealthContext();
    const { income, incomeTotal } = useWealth();
    const [showAll, setShowAll] = useState(false);

    const incomeColDefs = useBalanceSheetTableColDefs('incomeAndExpenses', clientCurrency ?? '', showAll);

    return (
        <div className="balance-sheet-table__container">
            <BalanceSheetCategoryTitle
                title={t('wealthIncomeSectionTitle')}
                totalText={t('wealthIncomeSectionTotal')}
                currency={clientCurrency}
                totalAmountCurrentYear={incomeTotal}
                showAll={showAll}
                onShowAllClick={setShowAll}
            />
            <BalanceSheetTable
                balanceSheetData={income}
                tableColDefs={incomeColDefs}
                showAll={showAll}
                enableCurrentYearFilter={true}
                onRowActionClick={handleShowModal}
            />
        </div>
    );
};
